/**
* Bepaalt of het opgegeven resultset een true resultproperty bevat (zowel boolean als string).
* @param resultset De opgegeven resultset
* @returns True als de opgegeven resultset een true resultproperty bevat.
*/
export function isResultTrue(resultset: { result: boolean | string }): boolean {
    return typeof resultset.result === "boolean" ? resultset.result : resultset.result.toUpperCase() === "TRUE";
}

/**
* Bepaalt of het opgegeven resultset een true resultvalueproperty bevat (zowel boolean als string).
* @param resultset De opgegeven resultset waarin property result én resultvalue zit
* @returns True als de opgegeven resultset een true resultvalueproperty bevat.
*/
export function isResultValueTrue(resultset: { resultvalue: boolean | string }): boolean {
    return typeof resultset.resultvalue === "boolean" ? resultset.resultvalue : resultset.resultvalue.toUpperCase() === "TRUE";
}

/**
* Submits huidige form
* @param eventTarget id van het element dat de form.submit veroorzaakt
* @param eventArgument bijbehorende argument, bijv. click of een bepaalde data-id 
* @returns Nothing
*/
export function SubmitForm(eventTarget: string, eventArgument?: string): void {
    let f: FormSubmitter = new FormSubmitter(document.forms[0], eventTarget, eventArgument);
    f.submitForm();
};

/**
* Hulpclass die huidige form kan submitten
*/
class FormSubmitter {
    constructor(private form: HTMLFormElement, private evTarget: string, private evArgument?: string) {
        if (!this.form) {
            throw new Error("form is null/undefined");
        }
    }

    public submitForm(): void {

        if (!this.form.onsubmit || this.form.onsubmit(new Event("fake")) != false) {
            this.checkform();
            this.form.__EVENTTARGET.value = this.evTarget;
            this.form.__EVENTARGUMENT.value = this.evArgument;
            this.form.submit();
        }
    }

    // als de standaardelementen niet bestaan, dan toevoegen
    private checkform(): void {
        this.checkAndAppendChildToForm("__EVENTTARGET")
        this.checkAndAppendChildToForm("__EVENTARGUMENT");
    }

    private checkAndAppendChildToForm(name: string): void {
        if (!this.form[name]) {
            let input: HTMLInputElement = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            input.id = name;
            this.form.appendChild(input);
        }
    }
}